export const _setReportsForm = (state, action) => action.payload;